import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { CommissionAccount } from '../../../commission-account/commission-account.model';
import { CommissionAccountService } from '../../../commission-account/commission-account.service';
import { UserClk } from '../../../users/users-clk/user-clk.model';
import { RequestParameters } from '../../models/request-parameters/parameter.model';

@Component({
  selector: 'app-commission-account',
  templateUrl: './commission-account-autocomplete.component.html',
  styleUrls: ['./commission-account-autocomplete.component.scss']
})
export class CommissionAccountComponent implements OnInit {
  @Input() commissionAccountFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onCommissionAccountSelected: EventEmitter<UserClk> = new EventEmitter<UserClk>();

  @ViewChild('autoCommissionAccount') autoCommissionAccount: ElementRef;

  commissionAccount: Observable<any> = new Observable<any>();
  commissionAccountLoading: boolean = true;
  commissionParameters: RequestParameters = new RequestParameters();
  constructor(private commissionAccountService: CommissionAccountService) {
    this.updateCommissionAccount();
   }

  ngOnInit() {
  }
  updateCommissionAccount(){
    this.commissionAccountLoading = true;
    this.commissionAccount = this.commissionAccountService.getAccounts(this.commissionParameters)
      .map(
        (response) => {
          this.commissionAccountLoading = false;
          return response.result;
        }
      );
  }
  filterCommission (filterInput: string = '') {
    if (this.commissionParameters.searchString !== filterInput) {
      this.commissionParameters.searchString = filterInput;
      this.updateCommissionAccount();
    }
  }
  displayCommissionAccount (commission: CommissionAccount) {
    if (commission !== null) {
      return commission.reference + ' -- ' + commission.prefixedBalance + ' ' + commission.country.name;
    }
  }
  onSelectCommission() {
    this.onCommissionAccountSelected.emit(this.commissionAccountFormControl.value);
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/commission-account-autocomplete/commission-account-autocomplete.component.ts